import React, { FC, useCallback, useEffect, useState } from "react";
import { CampaignBody } from "@vviinn/user-managment-client-ts";
import { isActive } from "../../../../../helpers";
import { getCampaignValue } from "../../modals/helpers";
import { calculateNewConfig } from "../../../helpers";
import { HandleCampaignChange } from "../../../../types";
import { AcceptableNamedRow } from "../../../../../ui/layout/organisms/SlideOver/SlideOverFixedLayouts/AcceptableNamedRow";
import { ObjectDetectionCollapsedFields } from "../../../../components/ObjectDetection/ObjectDetectionCollapsedFields";
import { UpdateCampaignProps } from "../../../types";

export const ObjectDetectionRow: FC<UpdateCampaignProps> = ({
  campaign,
  updateCampaignBody,
}) => {
  const [objectDetector, setObjectDetector] = useState(
    campaign?.objectDetector,
  );

  const [config, setConfig] = useState<CampaignBody>({});
  const [configChanged, setConfigChanged] = useState(false);

  useEffect(() => setConfigChanged(Object.keys(config).length > 0), [config]);

  const handleChange: HandleCampaignChange =
    (key, isNumberSettings) => (value) => {
      let campaignValue = getCampaignValue(key, campaign);

      setConfig(
        calculateNewConfig(isNumberSettings, config, key, value, campaignValue),
      );
    };

  const updateField = useCallback(() => {
    return updateCampaignBody(config);
  }, [config, updateCampaignBody]);

  return (
    <AcceptableNamedRow
      title="Object Detection"
      permissionsGroup="campaign:advanced_config"
      initConfig={() => {
        setConfig({});
        setObjectDetector(campaign?.objectDetector);
      }}
      onSubmit={updateField}
      allowSubmit={configChanged}
      content={isActive(campaign.useObjectDetection)}
    >
      <ObjectDetectionCollapsedFields
        campaign={campaign}
        objectDetector={objectDetector}
        setObjectDetector={setObjectDetector}
        handleChange={handleChange}
        isModal={true}
      />
    </AcceptableNamedRow>
  );
};
